<template>
  <div class="site-wrapper">
    <section class="section intro-section">
      <div class="section-inner">
        <div class="section-content">
          <!--  <g-title color="white" tag="h1" size="l">
            nude på
            <br />
            nätet
          </g-title> -->
          <!--   <g-title color="white" tag="h2">{{ startPage.Title }}</g-title> -->
          <h1 class="new-h1">NUDE PÅ NÄTET</h1>

          <h2 class="new-title">
            Okej att skicka nudes?
          </h2>
          <div class="new-body">
            Vad tycker
            <i>du?</i>
          </div>
          <div class="arrow-container">
            <img
              src="@/assets/svg/start_2.svg"
              class="arrows"
              style="margin:30px auto 0 auto;display:block;max-width:100%"
            />
          </div>
          <router-link
            :to="{ name: 'intro' }"
            style="margin:30px auto;display:block; position: relative; z-index: 10;"
          >
            <g-button color="pink" type="solid">Svara här</g-button>
          </router-link>
          <!--  <g-markdown :content="startPage.Text" class="section-markdown" /> -->
        </div>
        <div class="image-container">
          <img src="@/assets/png/start_0.png" class="section-image" />
        </div>
      </div>
    </section>
    <section class="section contact-section">
      <div class="section-inner">
        <div class="section-content">
          <g-title tag="h2" size="l">
            {{ startPage.ContactSection.Title }}
          </g-title>
          <g-markdown
            :content="startPage.ContactSection.Text"
            class="section-markdown"
          />
          <a
            v-for="(button, index) in startPage.ContactSection.Buttons"
            :key="index"
            target="_blank"
            :href="button.Link"
          >
            <g-button>{{ button.Label }}</g-button>
          </a>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import GET_START_PAGE from '@/graphql/GetStartPage.gql';
import PRELOAD_QUERY from '@/graphql/PreloadQuery.gql';

export default {
  components: {
    Footer
  },
  apollo: {
    startPage: {
      query: GET_START_PAGE
    }
  },
  data() {
    return {
      startPage: {
        Title: '',
        Text: '',
        ContactSection: {
          Title: '',
          Text: '',
          Buttons: []
        }
      }
    };
  },
  mounted() {
    this.$apollo.query({
      query: PRELOAD_QUERY
    });
  }
};
</script>

<style lang="scss" scoped>
.test {
  padding: 10px 30px;
}

.new-h1 {
  margin-bottom: 0;
  font-size: 24px;
  font-weight: 700;
}
.new-title {
  margin-top: 29px;
  margin-bottom: 26px;
  color: #fff;

  font-size: 74px;
  font-style: normal;
  font-weight: 700;
  line-height: 113%; /* 51.33px */

  i {
    position: relative;
    display: inline-block;
    margin-right: 8px;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 7px;
      background: #ff929a;
      bottom: -4px;
      left: 0;
    }
  }
}

.new-body {
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;

  i {
    position: relative;
    display: inline-block;
    margin-right: 8px;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 7px;
      background: #ff929a;
      bottom: 0px;
      left: 0;
    }
  }
}

.intro-section {
  overflow: hidden;
  //background-color: $green;

  background: url('~@/assets/png/grain-tile.png') 50px 50px repeat,
    radial-gradient(
      120.51% 150.49% at 118.15% 121.76%,
      #a1cc99 15%,
      #314940 100%
    );
  background-blend-mode: overlay, normal;
  background-position: center;
  color: $white;

  .section-content {
    padding-bottom: 30px;
  }

  .image-container {
    position: relative;
    max-width: $content-max-width;

    margin: -120px auto 0 auto;
    .section-image {
      margin-left: auto;
      position: relative;
      right: -60px;
      bottom: -16px;
      display: block;
      width: 340px;
    }
  }
}

.contact-section {
  background: url('~@/assets/png/grain-pink.png') 100px 100px repeat,
    radial-gradient(
      118.85% 148.95% at 4.49% -2.79%,
      #f8b0ba 0%,
      #fbd7d5 17.5%,
      #fce8e0 57.5%,
      #f1cbd6 100%
    );
  background-position: center;
  background-blend-mode: overlay, normal;
}

.section-content {
  margin: auto;
  max-width: $content-max-width;
  padding: 60px 20px 80px;
  width: 100%;
}

.section-markdown {
  margin-bottom: 24px;
}
</style>
